<template>
  <div>
    <el-select :value="value" value-key="key" :size="size" :disabled="disabled" @input="change($event)" :clearable="true">
      <el-option v-for="item in options" :key="item.key" :label="item.value" :value="item.key" />
    </el-select>
  </div>
</template>

<script>
export default {
  data () {
    return {
      emptyValue: { key: -1 },
      options: [{key: 0, value: '否'}, {key: 1, value: '是'}]
    }
  },
  props: ['value', 'config', 'size', 'disabled', 'showAllTip', 'showAllTipLabel'],
  methods: {
    change: function (val) {
      this.$emit('input', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/card/components/TrueOrFalseSelect.vue